import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('div',{staticClass:"div-not-found text-center"},[_c('h1',[_vm._v("Página não encontrada")]),_c(VBtn,{attrs:{"color":"primary"},on:{"click":function($event){return _vm.Helpers.logout()}}},[_c(VIcon,[_vm._v("mdi-keyboard-backspace")]),_vm._v("\n      Voltar\n    ")],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }